import React, { useEffect, useState } from 'react'
import { AddButton } from '../AllSvg';
import { Addbutton, CSSForSelectModern, ProgressModal } from '../CustomFunctions';
import { Modal } from 'react-bootstrap';
import { MonthOptions, Projects, YearOptions } from '../FilterDropdown';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import Select, { components } from "react-select";

import { CSSForSelect, CSSForSelect15vWWidth, handleErrorToast, sortProjects } from '../CustomFunctions';
import { Result } from 'antd';
import { Building2, Loader, MapPin, Sparkles, Tag, X } from 'lucide-react';

const AddMultipleVehicleBilling = ({ getData }) => {

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [month, setMonth] = useState("null");
    const [year, setYear] = useState("null");
    const [toggleProject, setToggleProject] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        project_ids: [],
        month: "null",
        year: "null",
        vehicle_ids: [],
    });

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData({
            project_ids: [],
            month: "null",
            year: "null",
            vehicel_ids: [],
        })

        setMonth("null");
        setYear('null');
        setToggleProject([]);
    }

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            month: month,
            year: year,
            project_ids: toggleProject
        }))
    }, [month, year, toggleProject]);

    const [vehicleList, ssetVehicleList] = useState([]);

    const getVehicleData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/vehicle-short/`)
        } catch (error) {
            console.error(error);

        }
    };

    useEffect(() => {
        if (show === true) {
            getVehicleData();
        }
    }, []);

    const [vehicleLogData, setVehicleLogData] = useState([]);

    const getVehicleLog = async () => {
        const month = String(formData.month).padStart(2, '0');
        const year = formData.year;

        const fromdate = `${year}-${month}-01`;

        const lastDay = new Date(year, month, 0).getDate();
        const todate = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/vehiclelogdetailbyallfilter/null/null/${fromdate}/${todate}/null/null/null/`);
            setVehicleLogData(response.data);

        } catch (error) {
            console.error(error);

        }
    };


    useEffect(() => {
        if (show === true && month !== "null" && year !== "null") {
            getVehicleLog()
        }
    }, [month, year])

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            'project_ids',
            'month',
            'year'


        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;

    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        })

        setFormData({
            ...formData,
            [name]: value
        })
    };



    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");



            try {
                let ress = await axios.post(
                    `${BASE_URL}/siteproject/finalgenerateVehicleCalculationByMultipleProjects/
`, formData
                );

                if (ress.status === 200) {
                    await getData();
                    handleClose();
                } else {
                    alert(ress);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    console.log("formData");

    console.log(formData);

    console.log(month, "month")
    console.log(year, "year")
    console.log(toggleProject, "toggleProject")

    return (
        <>
            <button title="Add Billing" className="clearbutton" onClick={handleShow}>
                <AddButton title='Bulk Billing' />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName='request-leave'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Vehicle Billing Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <Projects inputvalue="project_ids" usedFor="form" toggleProject={toggleProject} setToggleProject={setToggleProject} value="id" subcompany='null' error={errors.project_ids} SetErrors={setErrors} multiProject={true} />
                            <div className='flex-row justify-between'>

                                <MonthOptions toggleMonth={month} setToggleMonth={setMonth} inputvalue='month' error={errors.month} SetErrors={setErrors} />
                                <YearOptions toggleYear={year} setToggleYear={setYear} inputvalue='year' error={errors.year} SetErrors={setErrors} />
                            </div>
                        </div>
                        <div className='flex-row justify-around'>
                            <div>
                                <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                            </div>
                            <div>
                                <button class="submitaddbutton" onClick={handleFormSubmit} type='submit'>
                                    <span class="text">Submit</span>
                                    <span class="icon">
                                        <svg
                                            viewBox="0 0 24 24"
                                            height="24"
                                            width="24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z">
                                            </path>
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}
const AdMultipleImprestBilling = () => {
    return (
        <div></div>
    )
}
const AddMultipleOfficeRentBilling = ({ getData, subcompany }) => {

    const [projectIds, setProjectIds] = useState([]);

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const siteId = sessionStorage.getItem('sitemanagement_project');
    const role = sessionStorage.getItem('sitemanagement_role');
    const [projectId, setProjectId] = useState(null);

    const [toggleProject, setToggleProject] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [formData, setFormData] = useState({
        project_ids: [],
        bill_date: null,
    });

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setErrors({});
        setInputState({});
        setBillingType("null");
        setFormData({
            project_ids: [],
            bill_date: null,
        })
        setToggleProject([]);
    }

    const validateForm = () => {
        const newErrors = {};
        if (BillingType === "null") {
            newErrors.BillingType = "This field is required!";
        }
        if (formData.bill_date === null) {
            newErrors.bill_date = "This field is required!";
        }
        if (BillingType === "Multiple/All Sites" && projectIds.length === 0) {
            newErrors.projectIds = "This field is required!";
        }
        if (BillingType === "Single Site" && projectId === null) {
            newErrors.projectId = "This field is required!";
        }


        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            toast.dismiss();
            toast.warn("Fill all * fields");
            return false;
        }

        return true;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        })

        setFormData({
            ...formData,
            [name]: value
        })
    };
    const [buffer, setBuffering] = useState(true); //buffering logic

    useEffect(() => {


        const fetchProjects = async () => {
            setBuffering(true); //buffering logic // Start Buffering
            try {
                const role = sessionStorage.getItem("sitemanagement_role");
                const empId = sessionStorage.getItem("sitemanagement_emp_id");
                const url =
                    role === "AuthorityEngineer"
                        ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${empId}/null/null/null/`
                        : role === "DataEntryOperator"
                            ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/null/null/${empId}/null/`
                            : `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/null/null/null/null/`;

                const response = await axios.get(url);
                setToggleProject(response.data)

            } catch (error) {
                console.error("Error fetching projects:", error);
            } finally {
                setBuffering(false); //buffering logic // End Buffering
            }
        };

        fetchProjects();
    }, [subcompany]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setShowProgressModal(true);
            setLoading(true);
            setUploadProgress(0);

            const loadingToastId = toast.loading("Loading: Please wait...");

            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100);

            try {
                let ress = await axios.post(
                    `${BASE_URL}/siteproject/finalgenerateOfficeRentBillsbyMultipleProjects/
`, formData
                );

                if (ress.status === 200) {
                    await getData();
                    clearInterval(interval);
                    toast.dismiss(loadingToastId);
                    toast.success("Office Rent Bills Generated Successfully");
                    handleClose();
                }
            } catch (err) {
                clearInterval(interval);
                setUploadProgress(0);
                handleErrorToast(err);
            } finally {
                clearInterval(interval);
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 1500);
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };


    const Option = (props) => (
        <components.Option {...props}>

            <label title="Star" class="star">
                <input id="star-checkbox" checked={props.isSelected}
                    onChange={() => null} className="checkbox" type="checkbox" />
                <div className="svg-container">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-outline"
                        viewBox="0 0 24 24"
                    >
                        <path
                            d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"
                        ></path>
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-filled"
                        viewBox="0 0 24 24"
                    >
                        <path
                            d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"
                        ></path>
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="100"
                        width="100"
                        className="svg-celebrate"
                    >
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                    </svg>
                </div>
            </label>
            {props.label}
        </components.Option>
    );



    const MenuList = (props) => {
        const { options, selectProps } = props;

        const filteredOptions = options.filter(
            (opt) => opt.label.toLowerCase() !== "other"
        );

        const selectedValues = selectProps.value?.map((i) => i.value) || [];
        const filteredValues = filteredOptions.map((i) => i.value);

        const isAllSelected = filteredValues.every((val) =>
            selectedValues.includes(val)
        );

        const handleToggle = () => {
            if (isAllSelected) {
                const preserveOther = selectProps.value?.filter(
                    (i) => i.label.toLowerCase() === "other"
                ) || [];
                selectProps.onChange(preserveOther);
            } else {
                const preserveOther = selectProps.value?.filter(
                    (i) => i.label.toLowerCase() === "other"
                ) || [];
                selectProps.onChange([...filteredOptions, ...preserveOther]);
            }
        };

        return (
            <components.MenuList {...props}>
                <button
                    type="button"
                    onClick={handleToggle}
                    style={{
                        width: "100%",
                        padding: "6px 0",
                        cursor: "pointer",
                        fontWeight: "600",
                        borderBottom: "1px solid #e3e3e3",
                        background: "white"
                    }}
                >
                    {isAllSelected ? "Unselect All" : "Select All"}
                </button>

                {props.children}
            </components.MenuList>
        );
    };
    const [BillingType, setBillingType] = useState("null");
    const BillingTypeList = [{
        value: "Single Site", label: "Single Site"
    },
    { value: "Multiple/All Sites", label: "Multiple/All Sites" },
    { value: "All Sites", label: "All Sites" }
    ]

    const options = BillingTypeList
        .sort((a, b) => a.label - b.label)
        .map(i => ({
            value: i.value,
            label: `${i.label}`,
        }));

    const handleOptions = (options) => {
        if (!options) {
            setBillingType("null");
        } else {

            setBillingType(options.value);
        }
    };
    const projectOptions = toggleProject
        .sort((a, b) => a.site_prcode - b.site_prcode)
        .map(project => ({
            value: project.id,
            label: `${project.site_prcode} - ${project.project_short_name}`,
        }));



    const handleProjectOptions = (options) => {
        if (!options || options.length === 0) {
            setProjectIds([]);
        } else {
            const ids = options.map(opt => opt.value);
            setProjectIds(ids);
        }
    };
    const handleProjectOptionsSingle = (options) => {
        if (!options) {
            setProjectId(null);
        } else {
            setProjectId(options.value);
        }
    };

    useEffect(() => {
        if (BillingType === "Single Site") {
            setFormData((prev) => ({
                ...prev,
                project_ids: projectId && projectId !== "null" ? [projectId] : []
            }));
        }
        else if (BillingType === "Multiple/All Sites") {
            setFormData((prev) => ({
                ...prev,
                project_ids: projectIds
            }));
        }
        else if (BillingType === "All Sites") {
            const projectids = toggleProject.map((i) => i.id);
            setFormData((prev) => ({
                ...prev,
                project_ids: projectids
            }));
        }
    }, [BillingType, projectId, projectIds, toggleProject]);

    useEffect(() => {
        setProjectId(null);
        setProjectIds([]);

        setFormData((prev) => ({
            ...prev,
            project_ids: []
        }));
    }, [BillingType]);

    return (
        <>
            <button title="Generate Office Rent Bills" className="btn-animated" onClick={handleShow}>
                <Sparkles size={16} style={{ marginRight: "6px" }} /> Generate Bills
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Sparkles size={24} />
                            </div>
                            <div>
                                <Modal.Title>Generate Office Rent Bills</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Generate billing records for one, multiple, or all sites</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="form-section">
                            <div className="section-title">
                                <Building2 size={18} />
                                <h4>Billing Scope</h4>
                            </div>

                            <div className="form-grid">
                                {role !== "SiteManagement" && (
                                    <div className="form-field">
                                        <label><Tag size={14} /> Bill Type<span className="required">*</span></label>
                                        <Select
                                            options={options}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            placeholder="Select Bill Type"
                                            onChange={handleOptions}
                                            value={options.find(opt => opt.value === BillingType)}
                                            styles={CSSForSelectModern}
                                        />
                                        {errors.BillingType && <span className="error-message">{errors.BillingType}</span>}
                                    </div>
                                )}
                                <div className="form-field">
                                    <label> Bill Date<span className="required">*</span></label>
                                    <input
                                        type="date"
                                        id="bill_date"
                                        name="bill_date"
                                        onChange={handleInputChange}
                                        value={formData.bill_date}
                                        className={errors.bill_date ? "error" : inputState.bill_date ? "success" : ""}
                                    />
                                    {errors.bill_date && <span className="error-message">{errors.bill_date}</span>}
                                </div>

                                {(BillingType !== "All Sites" && BillingType !== "null" && role !== "SiteManagement") && (
                                    <div className="form-field full-width">
                                        <label><MapPin size={14} /> Site Project<span className="required">*</span></label>
                                        {BillingType === "Single Site" ? (
                                            <>
                                                <Select
                                                    options={projectOptions}
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    placeholder="Select Project"
                                                    onChange={handleProjectOptionsSingle}
                                                    value={
                                                        projectId
                                                            ? projectOptions.find(opt => opt.value === projectId)
                                                            : null
                                                    }
                                                    styles={CSSForSelectModern}
                                                />
                                                {errors.projectId && <span className="error-message">{errors.projectId}</span>}
                                            </>
                                        ) : BillingType === "Multiple/All Sites" ? (
                                            <>
                                                <Select
                                                    options={projectOptions}
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    placeholder="Select Projects"
                                                    onChange={handleProjectOptions}
                                                    value={
                                                        projectIds.length > 0
                                                            ? projectOptions.filter(opt => projectIds.includes(opt.value))
                                                            : []
                                                    }
                                                    styles={CSSForSelectModern}
                                                />
                                                {errors.projectIds && <span className="error-message">{errors.projectIds}</span>}
                                            </>
                                        ) : null}
                                    </div>
                                )}


                            </div>

                            <div className="form-actions">
                                <button type="button" className="btn-secondaryy" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button type="button" className="btn-primaryy" onClick={handleFormSubmit} disabled={loading}>
                                    {loading ? <Loader size={18} className="spinning" /> : <Sparkles size={18} />}
                                    <span>{loading ? 'Generating...' : 'Generate Bills'}</span>
                                </button>
                            </div>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    )

}
export { AddMultipleVehicleBilling, AdMultipleImprestBilling, AddMultipleOfficeRentBilling }